import * as Config from '../../../../config';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';
import AddPlaylist from '../../form/AddPlaylist';

import { setModal, addToast } from "../../../../actions/index";
import { setCartCounter, addCartItems, removeCartItems } from "../redux/actions/index";

const axios = require('axios');

const useCartStore = () => {
  const api = useSelector(state => state.api);
  const counter = useSelector(state => state.cartCounter)
  const storeRoute = useSelector(state => state.storeRoute)
  const isConnected = useSelector(state => state.isConnected);
  const dispatch = useDispatch();

  const defaultToastStack = {success: 0, duplicated: 0, alreadyBuy: 0, full: false, progress: [], stack: [], complete: false};
  const [toastsStack, setToastsStack] = useState(defaultToastStack);
  useEffect(() => {
    if (toastsStack.complete) {
      if (toastsStack.alreadyBuy > 0) {
        showModalAlreadyBuy(toastsStack.alreadyBuy);
      }
      if (toastsStack.duplicated > 0) {
        showModalDuplicate(toastsStack.duplicated);
      }
      if (toastsStack.success > 0) {
        showAddedItems(toastsStack.success);
      }
      if (toastsStack.full) {
        showModalCartFull();
      }
      setToastsStack({...defaultToastStack});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toastsStack])

  const showModalCartFull = (length = 1) => {
    dispatch(addToast({ content: <span>{length} track(s) not added to Cart. DJ App Cart limit is 100, please remove track(s) or checkout.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
  }

  const showModalDuplicate = (length) => {
    dispatch(addToast({ content: <span>{length} duplicate track(s) in Cart, track(s) not added.</span>, typeClass: 'warning', iconStyle: { padding: '24px 16px', marginRight: 16 } }));
  }

  const showModalAlreadyBuy = (length) => {
    dispatch(addToast({ content: <span>{length} previously purchased track(s) in Cart, track(s) not added.</span>, typeClass: 'warning', iconStyle: { padding: '24px 16px', marginRight: 16 } }));
  }

  const showAddedItems = (length) => {
    dispatch(addToast({ content: <span>{length} track(s) added to Cart.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }));
  }

  const showRemovedItems = (length) => {
    dispatch(addToast({ content: <span>{length} track(s) removed from Cart.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } }));
  }

  const showModalNoPurchasable = () => {
    dispatch(addToast({ content: <span>DJ Edits are streaming exclusives; unavailable for purchase.</span>, typeClass: 'warning', iconStyle: { padding: '24px 16px', marginRight: 16 } }));
  }

  const errorManagement = (error, length = 1) => {
    if (error.AlreadyPurchased) {
      showModalAlreadyBuy(length);
    } else if (error.AlreadyInCart) {
      showModalDuplicate(length);
    } else if (error.ItemLimit) {
      showModalCartFull();
    }
  }

  const executeSlice = (items, remainingItems, baseCounter) => {
    if (items.length) {
      toastsStack.stack = [];
      let success = 0;
      items.forEach( (id, index) => {
        const completeRequests = (id, send) => {
          toastsStack.stack.push(id);
          if (toastsStack.stack.length === items.length) {
            if (success + baseCounter < Config.MAX_CART_ITEMS && remainingItems.length > 0) {
              const partLength = Config.MAX_CART_ITEMS - success - baseCounter;              
              const dataSpliced = remainingItems.splice(0, partLength);
              executeSlice(dataSpliced, remainingItems, success + baseCounter);
            } else {
              setToastsStack({...toastsStack, complete: true});
            }
          }
        }
        if (success + baseCounter < Config.MAX_CART_ITEMS) {
          const source = axios.CancelToken.source();
          toastsStack.progress.push(source);
          api.post(`/my/default-cart/items/`, {
            "item_id": id,
            "item_type_id": Config.CART_ITEM_TYPE, // Track
            "audio_format_id": Config.CART_AUDIO_FORMAT, // MP3
            "purchase_type_id": Config.CART_PURCHASE_TYPE, // regular item purchase
            "source_type_id": Config.CART_SOURCE_TYPE
          }, { cancelToken: source.token }).then( res => {
            dispatch(setCartCounter(1));
            dispatch(addCartItems(id));
            toastsStack.success++;
            success++;
            const isFull = success + baseCounter >= Config.MAX_CART_ITEMS;
            if (isFull) {
              toastsStack.progress.forEach( source => source.cancel() )
              toastsStack.full = true;
            }
            completeRequests(id);
          }).catch(error => {
            if (error.response) {
              const response = error.response.data;
              if (response.AlreadyPurchased) {
                toastsStack.alreadyBuy++;
              } else if (response.AlreadyInCart) {
                toastsStack.duplicated++;
              } else if (response.ItemLimit) {
                toastsStack.full = true;
              } else if (response.AlbumOnly) {
                //TODO - ["Body is an album only track."]
              }
            }
            completeRequests(id);
          })
        } else if (success + baseCounter >= Config.MAX_CART_ITEMS) {
          toastsStack.full = true;
          completeRequests(id);
        }
      }); 
    }
  }

  const addItemsToCart = (items, duplicated, baseCartLength) => {
    if (isConnected) { // no bulk tracks endpoint avaible
      if (baseCartLength + 1 > Config.MAX_CART_ITEMS) {
        showModalCartFull(items.length + duplicated.length);
      } else if (items.length === 0 && duplicated.length > 0) {
        showModalDuplicate(duplicated.length);
      } else if (items.length) {
        toastsStack.duplicated = duplicated.length;

        const partLength = Config.MAX_CART_ITEMS - baseCartLength;
        const dataSpliced = items.splice(0, partLength);
        executeSlice(dataSpliced, items, baseCartLength);  
      }
    }
  }

  const removeItemsToCart = (items, afterCallback = null) => {
    const deleteItem = () => {
      items.forEach( (item, index) => {
        api.del(`/my/default-cart/items/${item.cartItemID}`).then( res => {
          dispatch(setCartCounter(-1));
          dispatch(removeCartItems(item.itemID));
          if (index + 1 === items.length) {
            showRemovedItems(items.length);
            if (afterCallback) { afterCallback(); }
            if (counter && (counter - items.length <= 0)) {
              storeRoute.goTo(`/cart/${Date.now()}`);
            }
          }
        })
      })
    }
    dispatch(setModal({ //V2
      content: (
        <ModalCTA
          title={`Remove track(s)`}
          description={`Are you sure you want to remove the selected track(s)?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Remove`} className={`red-white`} onClick={deleteItem} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`}  />
        </ModalCTA>
      )
    }))
  }

  const addItemsToPlaylist = (items) => {
    if (items.length > 0) {
      dispatch(setModal({ // V2
        content: (
          <ModalCTA
            title={`Select a playlist`}
            styleContainer={{marginTop: `-30%`, marginLeft: `0%`}}
            styleBody={{gap: 32}}
          >
            <AddPlaylist data={items} />
          </ModalCTA>
        )
      }));
    }
  }

  const goToCart = () => {
    const location = storeRoute.getLastLocation();
    if (!location.includes('cart')) {
      storeRoute.goTo(`/cart/${Date.now()}`);
    }
  }

  const storeX = {
    showModalCartFull,
    showModalDuplicate,
    showModalNoPurchasable,
    addItemsToCart,
    showAddedItems,
    removeItemsToCart,
    showRemovedItems,
    addItemsToPlaylist,
    goToCart,
    errorManagement
  };

  return storeX;
};

export default useCartStore;
